import { Directive, Input, OnChanges, inject } from '@angular/core';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { ThemeOptions, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsButton, DsButtonKind, DsButtonSize, DsButtonVariant } from '@frontend/ui/button';

@Directive({
    selector: '[msThemedButton]',
})
export class SportsThemedButtonDirective implements OnChanges {
    dsButton = inject(DsButton, { self: true });
    currentTheme = injectCurrentTheme();

    @Input() themeKind: ThemeOptions<DsButtonKind> = {};
    @Input() themeVariant: ThemeOptions<DsButtonVariant> = {};
    @Input() themeSize: ThemeOptions<DsButtonSize> = {};
    @Input() themeInverse: ThemeOptions<boolean> = {};

    ngOnChanges(changes: ISimpleChanges<SportsThemedButtonDirective>): void {
        if (changes.themeKind?.currentValue[this.currentTheme]) {
            const kind = changes.themeKind.currentValue[this.currentTheme];
            if (kind) {
                this.dsButton.kind.set(kind);
            }
        }

        if (changes.themeVariant?.currentValue[this.currentTheme]) {
            const variant = changes.themeVariant.currentValue[this.currentTheme];
            if (variant) {
                this.dsButton.variant.set(variant);
            }
        }

        if (changes.themeSize?.currentValue[this.currentTheme]) {
            const size = changes.themeSize.currentValue[this.currentTheme];
            if (size) {
                this.dsButton.size.set(size);
            }
        }
        if (changes.themeInverse?.currentValue[this.currentTheme]) {
            const inverse = changes.themeInverse.currentValue[this.currentTheme];
            if (inverse) {
                this.dsButton.inverse.set(inverse);
            }
        }
    }
}
